import type { VenuesListFilters } from "./types";
import { DEFAULT_PAGE_SIZE } from "./constants";

/**
 * Build the query string for `GET /api/admin/venues` from the page
 * filters. Empty / default values are omitted so the URL stays minimal
 * and the React Query cache key matches between the UI and the network
 * call. Returns an empty string (no leading `?`) when nothing is set,
 * so callers can do `${path}${buildVenuesQuery(filters)}` safely.
 */
export function buildVenuesQuery(filters: VenuesListFilters): string {
  const params = new URLSearchParams();

  const trimmed = filters.query.trim();
  if (trimmed.length > 0) params.set("query", trimmed);
  if (filters.status !== "all") params.set("status", filters.status);
  if (filters.type !== "all") params.set("type", filters.type);
  if (filters.page > 1) params.set("page", String(filters.page));
  if (filters.limit > 0 && filters.limit !== DEFAULT_PAGE_SIZE) {
    params.set("limit", String(filters.limit));
  }

  const qs = params.toString();
  return qs.length > 0 ? `?${qs}` : "";
}
